export enum AuthActions {
  SUCCESS_GET_SESSION = '@@auth/SUCCESS_GET_SESSION',
  FAILED_GET_SESSION = '@@auth/FAILED_GET_SESSION',
  SUCCESS_LOGIN = '@@auth/SUCCESS_LOGIN',
  FAILED_LOGIN = '@@auth/FAILED_LOGIN',
  SUCCESS_LOGOUT = '@@auth/SUCCESS_LOGOUT',
  FAILED_LOGOUT = '@@auth/FAILED_LOGOUT',
  SUCCESS_SIGNUP = '@@auth/SUCCESS_SIGNUP',
  FAILED_SIGNUP = '@@auth/FAILED_SIGNUP',
  SUCCESS_RECAPTCHA = '@@auth/SUCCESS_RECAPTCHA',
  RESET_RECAPTCHA = '@@auth/SUCCESS_RECAPTCHA',
  FAILED_VERIFY_EMAIL = '@@auth/FAILED_VERIFY_EMAIL',
  SENT_VERIFY_EMAIL = '@@auth/SENT_VERIFY_EMAIL',
  START_VERIFY_2FA = '@@auth/START_VERIFY_2FA',
  SUCCESS_VERIFY_2FA = '@@auth/SUCCESS_VERIFY_2FA',
  FAILED_VERIFY_2FA = '@@auth/FAILED_VERIFY_2FA',
  SUCCESS_FORGOT_PASSWORD = '@@auth/SUCCESS_FORGOT_PASSWORD',
  FAILED_FORGOT_PASSWORD = '@@auth/FAILED_FORGOT_PASSWORD',
  SUCCESS_RESET_PASSWORD = '@@auth/SUCCESS_RESET_PASSWORD',
  FAILED_RESET_PASSWORD = '@@auth/FAILED_RESET_PASSWORD',
  SUCCESS_DISABLE_RESET_PASSWORD = '@@auth/SUCCESS_DISABLE_RESET_PASSWORD',
  FAILED_DISABLE_RESET_PASSWORD = '@@auth/FAILED_DISABLE_RESET_PASSWORD',
  SET_RESET_KEY = '@@auth/SET_RESET_KEY',
  CLEAR_RESET_PASSWORD_STATUS = '@@auth/CLEAR_RESET_PASSWORD_STATUS',
  SET_VERIFYING_EMAIL = '@@auth/SET_VERIFYING_EMAIL',
  SET_VERIFYING_2FA = '@@auth/SET_VERIFYING_2FA',
  CLEAR_ERROR = '@@auth/CLEAR_ERROR',
  SET_ALLOW_TOKEN = '@@app/SET_ALLOW_TOKEN',
  SET_REJECT_TOKEN = '@@app/SET_REJECT_TOKEN'
}

interface SuccessGetSession {
  type: typeof AuthActions.SUCCESS_GET_SESSION,
  payload: any
}

interface FailedGetSession {
  type: typeof AuthActions.FAILED_GET_SESSION
}

interface SuccessLogin {
  type: typeof AuthActions.SUCCESS_LOGIN
}

interface FailedLogin {
  type: typeof AuthActions.FAILED_LOGIN
  payload: string
}

interface SuccessLogout {
  type: typeof AuthActions.SUCCESS_LOGOUT
}

interface FailedLogout {
  type: typeof AuthActions.FAILED_LOGOUT
}

interface SuccessSignUp {
  type: typeof AuthActions.SUCCESS_SIGNUP
}

interface FailedSignUp {
  type: typeof AuthActions.FAILED_SIGNUP
  payload: string
}

interface SuccessRecaptcha {
  type: typeof AuthActions.SUCCESS_RECAPTCHA
}

interface ResetRecaptcha {
  type: typeof AuthActions.SUCCESS_RECAPTCHA
}

interface FailedVerifyEmail {
  type: typeof AuthActions.FAILED_VERIFY_EMAIL
}

interface SentVerifyEmail {
  type: typeof AuthActions.SENT_VERIFY_EMAIL
}

interface StartVerify2fa {
  type: typeof AuthActions.START_VERIFY_2FA
}

interface SuccessVerify2fa {
  type: typeof AuthActions.SUCCESS_VERIFY_2FA
}

interface FailedVerify2fa {
  type: typeof AuthActions.FAILED_VERIFY_2FA
}

interface SuccessForgotPassword {
  type: typeof AuthActions.SUCCESS_FORGOT_PASSWORD
}

interface FailedForgotPassword {
  type: typeof AuthActions.FAILED_FORGOT_PASSWORD
  payload: string
}

interface SuccessResetPassword {
  type: typeof AuthActions.SUCCESS_RESET_PASSWORD
}

interface FailedResetPassword {
  type: typeof AuthActions.FAILED_RESET_PASSWORD
  payload: string
}

interface SuccessDisableResetPassword {
  type: typeof AuthActions.SUCCESS_DISABLE_RESET_PASSWORD
}

interface FailedDisableResetPassword {
  type: typeof AuthActions.FAILED_DISABLE_RESET_PASSWORD
  payload: string
}

interface SetResetKey {
  type: typeof AuthActions.SET_RESET_KEY
  payload: string
}

interface ClearResetPasswordStatus {
  type: typeof AuthActions.CLEAR_RESET_PASSWORD_STATUS
}

interface SetVerifyingEmail {
  type: typeof AuthActions.SET_VERIFYING_EMAIL
  payload: boolean
}

interface SetVerifying2FA {
  type: typeof AuthActions.SET_VERIFYING_2FA
  payload: boolean
}

interface ClearError {
  type: typeof AuthActions.CLEAR_ERROR,
  payload: number
}

interface SetAllowToken {
  type: typeof AuthActions.SET_ALLOW_TOKEN,
  payload: string | null
}

interface SetRejectToken {
  type: typeof AuthActions.SET_REJECT_TOKEN,
  payload: string | null
}

export type AuthActionType =
  SuccessGetSession |
  FailedGetSession |
  SuccessLogin |
  FailedLogin |
  SuccessLogout |
  FailedLogout |
  SuccessSignUp |
  FailedSignUp |
  SuccessRecaptcha |
  ResetRecaptcha |
  FailedVerifyEmail |
  SentVerifyEmail |
  StartVerify2fa |
  FailedVerify2fa |
  SuccessVerify2fa |
  SuccessForgotPassword |
  FailedForgotPassword |
  SuccessResetPassword |
  FailedResetPassword |
  SuccessDisableResetPassword |
  FailedDisableResetPassword |
  SetResetKey |
  ClearResetPasswordStatus |
  SetVerifyingEmail |
  SetVerifying2FA |
  ClearError |
  SetAllowToken |
  SetRejectToken
